export enum TextFieldVariant {
  DEFAULT,
  SEARCH,
}
